import React from 'react';
import styled from '@emotion/styled';
import { SkeletonItem } from '@atlaskit/menu';
import { SearchField } from '../../../billing-profile/src/components/search-and-filter/search-field';
import { CloudSitesList } from './cloud-sites-list';
import { CloudSiteInfo } from './add-new-products-modal';
import { token } from '@atlaskit/tokens';

interface Props {
  selectedCloudSite: CloudSiteInfo | null | undefined;
  setSelectedCloudSite: (data: CloudSiteInfo) => void;
  isBillingProfileDetailsLoading: boolean;
  isFetchEntitlementListLoading: boolean;
  clearSearchQuery: () => void;
  onQueryChange: (searchQuery: string) => void;
  cloudSitesList: CloudSiteInfo[];
  searchQuery?: string;
}

const StyledSearchAndFilterContainer = styled.div`
  margin-bottom: ${token('space.250')};
  display: flex;
  flex-direction: column;
`;

export const CloudSitesListContainer = ({
  selectedCloudSite,
  setSelectedCloudSite,
  isBillingProfileDetailsLoading,
  isFetchEntitlementListLoading,
  clearSearchQuery,
  onQueryChange,
  cloudSitesList,
  searchQuery,
}: Props) => {
  return (
    <section>
      <StyledSearchAndFilterContainer>
        <SearchField
          searchQuery={searchQuery}
          onQueryChange={onQueryChange}
          clearSearchQuery={clearSearchQuery}
          isDisabled={isFetchEntitlementListLoading || isBillingProfileDetailsLoading}
          showSearchIconBeforeInput={true}
          placeholder={'Search'}
        />
      </StyledSearchAndFilterContainer>
      {isBillingProfileDetailsLoading || isFetchEntitlementListLoading ? (
        <div>
          {Array.from({ length: 8 }).map((_, index) => (
            <SkeletonItem key={index} isShimmering hasIcon />
          ))}
        </div>
      ) : (
        <CloudSitesList
          cloudSitesList={cloudSitesList}
          selectedCloudSite={selectedCloudSite}
          setSelectedCloudSite={setSelectedCloudSite}
        />
      )}
    </section>
  );
};
